/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdListProps, TdListItemProps, TdListItemMetaProps } from './type';

export const listDefaultProps: TdListProps = { layout: 'horizontal', size: 'medium', split: false, stripe: false };

export const listItemDefaultProps: TdListItemProps = {};

export const listItemMetaDefaultProps: TdListItemMetaProps = {};
